module.exports = __webpack_public_path__ + "img/i3iot2.b1e90ce0.png";